export function pad2(n: number) {
  return (n < 10 ? "0" : "") + n;
}
